module.exports = __webpack_public_path__ + "img/2151.75a0036c.gif";